module.exports = __webpack_public_path__ + "static/media/5.10fb3d2d.svg";